'use strict';

const $body = $('body');
const $main = $('main');
const $customSearch = $('.custom-search');
const $formSearch = $('.custom-search__form .form-search');
const $clearBtn = $('.custom-search__header .clear-search');
const $closeBtn = $('.custom-search__close');
const $openBtn = $('.button-search');

function toggleSearch(open) {
    $customSearch.toggleClass('show', open);
    $main.toggleClass('overlay', open);
    $body.toggleClass('lock-body search-open', open);
}

// Open search
function bindOpenSearch() {
    $openBtn.off('click').on('click', () => toggleSearch(true));
}

// Close search
function bindCloseSearch() {
    $closeBtn.off('click').on('click', () => toggleSearch(false));
}

// Show/hide clear button on input
function bindToggleClearButton() {
    $formSearch.off('input').on('input', function () {
        $clearBtn.toggle(!!this.value);
        $customSearch.addClass('is-typing');
    });
}

// Clear search input
function bindClearSearch() {
    $clearBtn.off('click').on('click', function (e) {
        e.preventDefault();
        $formSearch.val('').focus();
        $clearBtn.hide();
        $customSearch.removeClass('is-typing');
    });

    $main.off('click.searchOverlay').on('click.searchOverlay', function (e) {
        if ($main.hasClass('overlay')) {
            if (e.target === $main[0]) {
                toggleSearch(false);
            }
        }
    });
}

module.exports = function () {
    bindOpenSearch();
    bindCloseSearch();
    bindToggleClearButton();
    bindClearSearch();
};